export default "__VITE_ASSET__25e9b80f__"